@import "~@govbr-ds/core/src/components/signin/signin";

:host {
  display: inline-block;
}

:host([shape="block"]) {
  display: block;
  width: 100%;
}

.br-sign-in {
  @include button-configs;
  @include signin-configs;

  &.secondary {
    border: 0;
    background-color: var(--background);
  }

  &[aria-disabled="true"] {
    cursor: not-allowed;
    pointer-events: none;
  }
}

[part="image"] {
  display: inline-flex;
  align-items: center;
  margin-left: var(--spacing-scale-half);
}

::slotted([slot="image"]) {
  max-height: var(--sign-in-img);
}
